export function connectionState(last, failed, now = Date.now(), windowMs = 15000) {
    if (!last) return failed ? "offline" : "connecting";
    if (now - last > windowMs * 3) return "offline";
    return failed || now - last > windowMs ? "reconnecting" : "live";
}
export function netherCoordinates(x, z, toNether = true) {
    if (!Number.isFinite(x) || !Number.isFinite(z)) return null;
    const factor = toNether ? 1 / 8 : 8;
    return { x: Math.floor(x * factor), z: Math.floor(z * factor) };
}
export function distance(a, b) {
    return Math.hypot(b.x - a.x, b.y - a.y);
}
export function locationUrl(base, world, point, zoom) {
    const url = new URL(base);
    url.search = new URLSearchParams({
        world,
        x: Math.floor(point.x),
        z: Math.floor(point.y),
        zoom,
    }).toString();
    return url.href;
}
export function freshTelemetry(data, now = Date.now()) {
    return (
        !!data && Number.isFinite(data.generatedAt) && now - data.generatedAt < 20000 && now - data.generatedAt >= -5000
    );
}

export function worldClock(ticks) {
    if (!Number.isFinite(ticks)) return null;
    const cycle = ((ticks % 24000) + 24000) % 24000;
    const minutes = Math.floor((((cycle + 6000) % 24000) * 1440) / 24000);
    return {
        time: `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`,
        night: cycle >= 13000 && cycle < 23000,
        angle: (cycle / 24000) * 360 - 90,
    };
}
export function regionMetrics(data) {
    if (!freshTelemetry(data) || data.regionsAvailable !== true || !Array.isArray(data.regions)) return null;
    return data.regions
        .filter((r) => r && typeof r.id === "string" && typeof r.world === "string")
        .map((r) => ({
            ...r,
            valid: Number.isFinite(r.tps) && r.tps >= 0 && r.tps <= 20 && Number.isFinite(r.mspt) && r.mspt >= 0,
        }))
        .sort(
            (a, b) =>
                (a.valid ? a.tps : 21) - (b.valid ? b.tps : 21) ||
                a.world.localeCompare(b.world) ||
                a.id.localeCompare(b.id),
        );
}

export function resourcePercent(value) {
    return Number.isFinite(value) && value >= 0 && value <= 100 ? value : null;
}
